import { render, staticRenderFns } from "./TechMap.vue?vue&type=template&id=0bfd423c"
import script from "./TechMap.vue?vue&type=script&lang=js"
export * from "./TechMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports